const interests = [
  'fight club',
  'hiking',
  'walking',
  'partying',
  'museums',
  'galleries',
  'extreme sports',
  'tennis',
  'running',
  'cycling',
  'badminton',
  'table tennis',
  'board games',
  'eating out',
  'coffee',
  'beer',
  'urban exploring',
  'pokemon go',
  'cinema',
  'cocktails',
  'frisbee',
  'park hang',
  'picnic',
  'disc golf',
  'arts and crafts',
  'bowling',
  'cheese rolling',
  'shopping',
  'theme parks',
  'tea ceremonies',
  'gong baths',
  'yoga',
  'cooking',
  'live music'
];

// module.exports = {
//   interests
// }
export default interests;
